module.exports = __webpack_public_path__ + "static/media/cq_oggi_option b.0bc7bfe8.svg";